module.exports = __webpack_public_path__ + "img/坏笑.a94a99b2.png";